module.exports = __webpack_public_path__ + "bb00e7fbd4d36f6737036392c2d05cc3.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/hidromat.png
// module id = 603
// module chunks = 0